(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var SHEET_KEY = 'bkb_bottom_sheet_views';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function initListing(root) {
    root.classList.add('bkb-js');
    var sectionId = root.getAttribute('data-section');
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-bkb-more]');
      if (!more) return;
      e.preventDefault();
      if (more.hasAttribute('disabled')) return;
      more.setAttribute('disabled', '');
      var url = more.getAttribute('href');
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-bkb-grid]');
          var nextGrid = doc.querySelector('[data-bkb-grid]');
          if (grid && nextGrid) {
            while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);
          }
          var count = root.querySelector('[data-bkb-count]');
          var nextCount = doc.querySelector('[data-bkb-count]');
          if (count && nextCount) count.textContent = nextCount.textContent;
          var nextMore = doc.querySelector('[data-bkb-more]');
          if (nextMore) {
            more.setAttribute('href', nextMore.getAttribute('href'));
            more.removeAttribute('disabled');
          } else {
            more.parentNode.removeChild(more);
          }
        })
        .catch(function () { window.location.href = url; });
    });
  }

  function feedCard(item) {
    var a = el('a', 'bkb-card');
    a.href = item.u;
    var img = el('span', 'bkb-card__img');
    if (item.i) {
      var i = el('img');
      i.src = item.i;
      i.alt = item.t;
      i.loading = 'lazy';
      img.appendChild(i);
    } else {
      img.appendChild(el('span', 'bkb-card__ph', 'Barkyn'));
    }
    var body = el('span', 'bkb-card__body');
    if (item.c) body.appendChild(el('span', 'bkb-card__cat', item.c));
    body.appendChild(el('span', 'bkb-card__title', item.t));
    a.appendChild(img);
    a.appendChild(body);
    return a;
  }

  function initHome(root) {
    var data = root.querySelector('[data-bkb-feed]');
    var btn = root.querySelector('[data-bkb-feed-more]');
    var grid = root.querySelector('[data-bkb-grid]');
    if (!data || !btn || !grid) return;
    var items;
    try { items = JSON.parse(data.textContent); } catch (e) { items = []; }
    var step = parseInt(root.getAttribute('data-step'), 10) || 6;
    var pos = 0;
    btn.addEventListener('click', function () {
      items.slice(pos, pos + step).forEach(function (it) { grid.appendChild(feedCard(it)); });
      pos += step;
      if (pos >= items.length) btn.parentNode.removeChild(btn);
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-bkb-car-track]');
    var prev = root.querySelector('[data-bkb-car-prev]');
    var next = root.querySelector('[data-bkb-car-next]');
    if (!track || !prev || !next) return;
    function stepSize() {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : 300;
    }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bkb-copy]');
      if (!btn || !navigator.clipboard) return;
      navigator.clipboard.writeText(window.location.href).then(function () {
        var ok = btn.closest('.bkb-share').querySelector('[data-bkb-copied]');
        if (!ok) return;
        ok.hidden = false;
        setTimeout(function () { ok.hidden = true; }, 2500);
      });
    });
  }

  function initSheet(sheet) {
    var max = parseInt(sheet.getAttribute('data-max'), 10) || 3;
    var delay = (parseInt(sheet.getAttribute('data-delay'), 10) || 0) * 1000;
    var views = 0;
    try { views = parseInt(localStorage.getItem(SHEET_KEY), 10) || 0; } catch (e) {}
    if (views >= max || window.matchMedia('(min-width: 768px)').matches) return;
    try { localStorage.setItem(SHEET_KEY, String(views + 1)); } catch (e) {}
    sheet.hidden = false;
    setTimeout(function () { sheet.classList.add('is-open'); }, delay);
    var close = sheet.querySelector('[data-bkb-sheet-close]');
    if (close) {
      close.addEventListener('click', function () {
        sheet.classList.remove('is-open');
        try { localStorage.setItem(SHEET_KEY, String(max)); } catch (e) {}
      });
    }
  }

  function initMail(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.elements.email.value || '').trim();
      var err = form.querySelector('[data-bkb-mail-err]');
      if (form.elements.company && form.elements.company.value) return;
      if (!EMAIL_RE.test(email)) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      var payload = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              $source: 'Blog Ebook Banner',
              'Accepts Marketing': true,
              blog_banner: form.getAttribute('data-banner'),
              blog_market: form.getAttribute('data-market'),
              blog_source_url: window.location.pathname
            },
            metric: { data: { type: 'metric', attributes: { name: 'Blog Ebook Requested' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-02-15' },
        body: JSON.stringify(payload)
      }).catch(function () {});
      var row = form.querySelector('[data-bkb-mail-form]');
      var consent = form.querySelector('[data-bkb-mail-consent]');
      var ok = form.querySelector('[data-bkb-mail-ok]');
      if (row) row.hidden = true;
      if (consent) consent.hidden = true;
      if (ok) ok.hidden = false;
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bkb-listing]'), initListing);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bkb-home]'), initHome);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bkb-car]'), initCarousel);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bkb-sheet]'), initSheet);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bkb-mail]'), initMail);
    initCopy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
